import { Component, Inject, OnInit } from '@angular/core';
import { UserService } from '@services/user.service';
import { AppComponent } from 'app/app.component';
import { Authorization } from 'app/shared/classes/authorization';
import { CommonShared } from 'app/shared/classes/common';
import moment from 'moment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';
import { KigSettings, KIG_SETTINGS } from 'settings/kig-settings';
import { ChangeLogNotesParams, ChangeLogNotesComponent } from 'app/components/messages/changelog-notes/changelognotes.components';
import { AppComponentName, ItemType, Message, MessageActionType, MessageType, UserAssociatedCatagory, UserAssociatedItem, UserGroup, UserInfos } from '@models';
import { CloudFileStorage } from '@models/Device/CloudFileStorage.model';
import { AppMessageService } from '@services/message.service';


export interface UserDetailsParams {
  userInfo: UserInfos;
  userIsAdmin: boolean;
  allUserGroups: UserGroup[];
  adminUserGroup: UserGroup;
}


@Component({
  standalone: false,
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss']
})

export class UserDetailsComponent implements OnInit, UserDetailsParams {

  auth = new Authorization();
  common = new CommonShared();

  modalDragOn: boolean = false;

  userInfo: UserInfos;
  userIsAdmin: boolean;
  allUserGroups: UserGroup[] = [];
  adminUserGroup: UserGroup;

  associatedUserGroups: UserGroup[] = [];
  userAssociatedItems: UserAssociatedItem[] = [];
  userAssociatedCategories: UserAssociatedCatagory[] = [];
  
  selectedUserGroup: UserGroup = undefined;

  public userGroupCols = [
    {field: 'name', header: 'Group Name', width: '70%'},
    {field: 'userInfos', header: '#Members', width: '15%'},
    {field: 'status', header: 'Membership', width: '15%'}
  ];

  public userItemsCols = [
    {field: 'name', header: 'Name', width: '40%'},
    {field: 'type', header: 'Category', width: '20%'},
    {field: 'owner', header: 'Owner', width: '40%'},
  ];

  public userCategoryCols = [
    {field: 'category', header: 'Category', width: '40%' },
    {field: 'itemCount', header: 'Total Items', width: '20%'},
    {field: 'userOwnedCount', header: 'Self Owned', width: '20%'},
    {field: 'groupOwnedCount', header: 'Group Owned', width: '20%'},
  ];

  public userGroupconfig: any = {
    displayKey: 'name',
    search: true,
    height: '300px',
    placeholder: 'Select User Group',
    noResultsFound: 'No User Groups found!',
    searchOnKey: 'name'
  };


  logModalRef: BsModalRef;
  username = 'unknown';
  preEditObjectAsJSONString = '';
  changeLogNotes = '';

  readonly globalSwitch: boolean;


  constructor(public bsModalRef: BsModalRef, private toastr: ToastrService, private modalService: BsModalService,
    public global: AppComponent, private confirmationService: ConfirmationService, public _appMessageService: AppMessageService,
    @Inject(KIG_SETTINGS) private settings: KigSettings, public _userService: UserService) {
    this.globalSwitch = global.globalSwitch;
  }


  ngOnInit(): void {
    this._userService.getCurrentUserEmailUsingAzureAD().subscribe(
      results => {
        this.username = results['value'];
        if (this.username != null && this.username !== '') {
          this.startUp();
        }
      },
      () => {
        this.toastr.error('Error unable to read current user\'s info');
      });
  }

  startUp(): void {
    this.getAssociatedUserGroups();
    this.getAssociatedUserItems();
  }


  setDragOn(drag: boolean) {
    this.modalDragOn = drag;

    if (drag) {
      setTimeout(() => {
        this.modalDragOn = false;
      },3000);
    }
  }


  getAssociatedUserGroups(): void {
    this._userService.getAssociatedUserGroups(this.userInfo.userName).subscribe(
      results => {
        if (results != null) {
          this.associatedUserGroups = results;
          this.associatedUserGroups.forEach(x => {
            x.status = 'active';
            x.checked = true;
          });
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving current display.');
      }
    );
  }


  createUserInfo(userName: string): UserInfos {
    var newUser: UserInfos = {
      id: -1,
      userName: userName
    };
    return newUser
  }


  getAssociatedUserItems(): void {
    this._userService.getAssociatedItems(this.userInfo.userName).subscribe(
      results => {
        if (results != null) {
          this.userAssociatedItems = results
          this.userAssociatedItems.forEach(x => x.type = this.mapItemType(Number(x.type)));
          this.buildAssociatedCategories(this.userAssociatedItems);
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving items associated with user.');
      }
    );
  }


  buildAssociatedCategories(userItems: UserAssociatedItem[]) {
    var userCategory: UserAssociatedCatagory = {
      category: ItemType.ChartFavorite,
      itemCount: userItems.filter(x => x.type == ItemType.ChartFavorite).length,
      userOwnedCount: userItems.filter(x => x.type == ItemType.ChartFavorite && x.ownerName == "Self").length,
      groupOwnedCount: userItems.filter(x => x.type == ItemType.ChartFavorite && x.ownerName != "Self").length
    };
    this.userAssociatedCategories.push(userCategory);

    var userCategory: UserAssociatedCatagory = {
      category: ItemType.Dashboard,
      itemCount: userItems.filter(x => x.type == ItemType.Dashboard).length,
      userOwnedCount: userItems.filter(x => x.type == ItemType.Dashboard && x.ownerName == "Self").length,
      groupOwnedCount: userItems.filter(x => x.type == ItemType.Dashboard && x.ownerName != "Self").length
    };
    this.userAssociatedCategories.push(userCategory);

    var userCategory: UserAssociatedCatagory = {
      category: ItemType.Gateway,
      itemCount: userItems.filter(x => x.type == ItemType.Gateway).length,
      userOwnedCount: userItems.filter(x => x.type == ItemType.Gateway && x.ownerName == "Self").length,
      groupOwnedCount: userItems.filter(x => x.type == ItemType.Gateway && x.ownerName != "Self").length
    };
    this.userAssociatedCategories.push(userCategory);

    var userCategory: UserAssociatedCatagory = {
      category: ItemType.EventAction,
      itemCount: userItems.filter(x => x.type == ItemType.EventAction).length,
      userOwnedCount: userItems.filter(x => x.type == ItemType.EventAction && x.ownerName == "Self").length,
      groupOwnedCount: userItems.filter(x => x.type == ItemType.EventAction && x.ownerName != "Self").length
    };
    this.userAssociatedCategories.push(userCategory);

    var userCategory: UserAssociatedCatagory = {
      category: ItemType.ImportSchedule,
      itemCount: userItems.filter(x => x.type == ItemType.ImportSchedule).length,
      userOwnedCount: userItems.filter(x => x.type == ItemType.ImportSchedule && x.ownerName == "Self").length,
      groupOwnedCount: userItems.filter(x => x.type == ItemType.ImportSchedule && x.ownerName != "Self").length
    };
    this.userAssociatedCategories.push(userCategory);

    var userCategory: UserAssociatedCatagory = {
      category: ItemType.Message,
      itemCount: userItems.filter(x => x.type == ItemType.Message).length,
      userOwnedCount: userItems.filter(x => x.type == ItemType.Message && x.ownerName == "Self").length,
      groupOwnedCount: userItems.filter(x => x.type == ItemType.Message && x.ownerName != "Self").length
    };
    this.userAssociatedCategories.push(userCategory);

    var userCategory: UserAssociatedCatagory = {
      category: ItemType.SensorGroup,
      itemCount: userItems.filter(x => x.type == ItemType.SensorGroup).length,
      userOwnedCount: userItems.filter(x => x.type == ItemType.SensorGroup && x.ownerName == "Self").length,
      groupOwnedCount: userItems.filter(x => x.type == ItemType.SensorGroup && x.ownerName != "Self").length
    };
    this.userAssociatedCategories.push(userCategory);

    var userCategory: UserAssociatedCatagory = {
      category: ItemType.Sensor,
      itemCount: userItems.filter(x => x.type == ItemType.Sensor).length,
      userOwnedCount: userItems.filter(x => x.type == ItemType.Sensor && x.ownerName == "Self").length,
      groupOwnedCount: userItems.filter(x => x.type == ItemType.Sensor && x.ownerName != "Self").length
    };
    this.userAssociatedCategories.push(userCategory);

    var userCategory: UserAssociatedCatagory = {
      category: ItemType.ScoutviewImages,
      itemCount: userItems.filter(x => x.type == ItemType.ScoutviewImages).length,
      userOwnedCount: userItems.filter(x => x.type == ItemType.ScoutviewImages && x.ownerName == "Self").length,
      groupOwnedCount: userItems.filter(x => x.type == ItemType.ScoutviewImages && x.ownerName != "Self").length
    };
    this.userAssociatedCategories.push(userCategory);
  }


  userGroupSelected(userGroup: UserGroup) {
    userGroup.checked != userGroup.checked;
  }


  mapItemType(index: number): ItemType {
    const enumString = (index >= 0) ? Object.values(ItemType)[index] : '';

    switch (enumString) {
      case "ChartFavorite":
          return ItemType.ChartFavorite;

      case "Dashboard":
        return ItemType.Dashboard;

      case "Gateway":
        return ItemType.Gateway;

      case "EventAction":
        return ItemType.EventAction;

      case "ImportSchedule":
        return ItemType.ImportSchedule;

      case "Message":
        return ItemType.Message;

      case "SensorGroup":
        return ItemType.SensorGroup;

      case "Sensor":
        return ItemType.Sensor;

      case "ScoutviewImages":
        return ItemType.ScoutviewImages;
        
      default:
        return ItemType.ChartFavorite;
    }
  }


  addNotes2ChangeLog() {
    this.changeLogNotes = '';
    
    const params: ChangeLogNotesParams = {
      changeLogNotes: this.changeLogNotes,
      userGroupId: 0,
      category: ''
    };

    var modalRef = this.modalService.show(ChangeLogNotesComponent, { animated: false, backdrop: false, ignoreBackdropClick: true, class: 'modal-above-confirmdialog', initialState: params });
    modalRef.content.onChangeLogNotes.subscribe((value) => {
      this.changeLogNotes = value;
    });
  }


  updateUserDetails(userInfo: UserInfos, bsModalRef: any) {
    this.associatedUserGroups.forEach(x => {
      if (!x.checked) {                                                           // user unchecked from group
        if (x.userInfos.length < 2) {                                             // add the Admins users to the group if no one will be left in group
          this.adminUserGroup.userInfos.forEach(y => {
            var adminUserIndex = x.userInfos.findIndex(z => z.id == y.id);
            if (adminUserIndex == -1) {
              x.userInfos.push(y);
            }
          }); 
        }
        
        var userIndexInGroup = x.userInfos.findIndex(y => y.id == userInfo.id);   // find and remove user from current group if others in group
        if (userIndexInGroup != -1) {
          x.userInfos.splice(userIndexInGroup, 1);
        }
        this.updateUserGroup(x);
      }
    });

    if (this.selectedUserGroup != undefined && this.selectedUserGroup.id > 0) {
      this.replaceUserOwnedItemsWithGroup(userInfo, this.selectedUserGroup);
    }

    bsModalRef.hide();
  }


  updateUserGroup(userGroup: UserGroup) {
    this._userService.updateUserGroup(userGroup).subscribe(
      results => {
        if (results != null) {
          this.toastr.success('Success: ' + userGroup.name + ' updated');
          this.createMessageData( MessageActionType.Edited, userGroup, this.getEditChanges(userGroup));
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while updating user groups.');
      });
  }


  replaceUserOwnedItemsWithGroup(userInfo: UserInfos, selectedUserGroup: UserGroup) {
    var userGroup = (selectedUserGroup != undefined) ? selectedUserGroup : this.adminUserGroup;

    this._userService.replaceUserOwnedItemsWithGroup(userInfo.id, userGroup.id).subscribe(
      results => {
        if (results == null) {
          this.toastr.success('Success: ' + userInfo.userName + ' self-owned items switched to ' + userGroup.name);
        }
        else {
          this.toastr.error('Warning: ' + results);
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while updating user owned items.');
      });
  }


  createMessageData(msgActionType: MessageActionType, userGroup: UserGroup, msgNote: string) {
    const message: Message = {
      id: 0,
      messageType: MessageType.Audit,
      appComponentName: AppComponentName.UserGroups,
      actionType: msgActionType,
      appComponentItem: userGroup.name,
      details: msgNote,
      userNotes: this.changeLogNotes,
      count: 1,
      acknowledged: false,
      userName: this.username,
      userGroupId: null
    };

    this._appMessageService.createAppMessage(message).subscribe(
      results => {
        if (results != null) {
          //this.toastr.success('Success');
        } else {
          //this.toastr.warning('Not found.');
        }
        return;
      },
      err => {
        //this.toastr.error('Error occurred while saving change log.');
      });
  }


  getEditChanges(userGroup: UserGroup): string {
    let results = '';

    if (this.preEditObjectAsJSONString !== '') {
      const original: UserGroup = JSON.parse(this.preEditObjectAsJSONString);
      results += this.common.compareProperty('Name', original.name, userGroup.name);
      results += this.common.compareProperty('Enable', this.common.prepareProperty4String(!original.isdisabled), this.common.prepareProperty4String(!userGroup.isdisabled));
      results += this.common.compareProperty('Description', original.description, userGroup.description);
      results += this.common.compareProperty('Status', original.status, userGroup.status);
      results += this.common.compareProperty('UserCount', original.userInfos.length.toString(), userGroup.userInfos.length.toString());
      results += this.compareUserInfos(original.userInfos, userGroup.userInfos);
    }

    return results;
  }


  compareUserInfos(origUserInfos: UserInfos[], newUserInfos: UserInfos[]): string {
    var results: string = '';
    if (newUserInfos == undefined) return results;

    newUserInfos.forEach(u => {
      var userInfo = origUserInfos.find(o => o.id == u.id);
      if (userInfo != undefined) {
        if (userInfo.role != u.role) {
          results += 'Role for ' + u.userName + ' (' + userInfo.role + ' -> ' + u.role + '),  ';
        }
      }
    });
    return results;
  }


}
